module.exports = __webpack_public_path__ + "static/img/guide-21.6460f305.png";